import VaultedPaymentMethodIdReactNative from "../../../../content/sdk/react-native/2.x.x/primerHeadlessUniversalCheckout/_vaultManager/_common/VaultedPaymentMethodIdReactNative.mdx";
import ValidationErrorReactNative from "../../../../content/sdk/react-native/2.x.x/primerHeadlessUniversalCheckout/_vaultManager/_common/ValidationErrorReactNative.mdx";
import VaultedPaymentMethodDataReactNative from "../../../../content/sdk/react-native/2.x.x/primerHeadlessUniversalCheckout/_vaultManager/_common/VaultAdditionalDataReactNative.mdx";
import * as React from 'react';
export default {
  VaultedPaymentMethodIdReactNative,
  ValidationErrorReactNative,
  VaultedPaymentMethodDataReactNative,
  React
};